export const getAddonsForTicket =
  (attendees_attributes = []) =>
  (id) =>
    Object.values(
      attendees_attributes
        .filter(({ ticket_id }) => id === ticket_id)
        .map(({ addons_attributes }) =>
          addons_attributes.filter(({ quantity }) => quantity > 0),
        )
        .flat()
        .reduce(
          (addons, addon) => ({
            ...addons,
            [addon.id]: {
              ...addon,
              quantity: (addons[addon.id]?.quantity || 0) + 1,
            },
          }),
          {},
        ),
    );
